import { env } from "../../../env";
const axios = require("axios").default;

const URL_ORI = `${env.REACT_APP_API_URL}`;

export const getOffice = (payload) => {
  return axios
    .get(`${URL_ORI}/api/office/search`, {
      params: payload,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const createOffice = (payload) => {
  return axios.post(`${URL_ORI}/api/office`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

export const createOfficeSequence = (payload) => {
  return axios
    .post(`${URL_ORI}/api/office/sequence`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const getIdOffice = (id) => {
  return axios
    .get(`${URL_ORI}/api/office/${id}`, {
      params: id,
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const updateOffice = (payload) => {
  return axios.put(`${URL_ORI}/api/office`, payload).catch((error) => {
    if (error.response) {
      return error.response;
    } else if (error.request) {
      console.log(error.request);
    } else {
      console.log(error.message);
    }
  });
};

// export const deleteById = (payload) => {
//   return axios.delete(URL, payload).catch((error) => {
//     if (error.response) {
//       return error.response;
//     } else if (error.request) {
//       console.log(error.request);
//     } else {
//       console.log(error.message);
//     }
//   });
// };

export const uploadImage = (id, file) => {
  const formData = new FormData();
  formData.append("file", file);

  return axios
    .post(`${URL_ORI}/api/office/imageAction/?id=${id}`, formData)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};

export const deleteImageOffice = (payload) => {
  return axios
    .post(`${URL_ORI}/api/office/deleteImage`, payload)
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log(error.message);
      }
    });
};
